import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { RootState } from '../appReducer'

type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>

export const useAppDispatch = () => useDispatch<AppDispatch>()
